import { useState, useCallback } from "react";
import displayToastMessage from "../components/Common/Alert/displayToastMessage";

const HttpMethods = {
  GET: "get",
  PUT: "put",
  POST: "post",
  DELETE: "delete",
  PATCH: "patch",
}
const useHttp = () => {
  const [error, setError] = useState(false);
  const sendRequest = useCallback(
    async (
      config,
      responseAction,
      failureAction,
      fullResponse = false
    ) => {
      try {
        const method = config?.method
          ? config?.method
          : HttpMethods.GET;
        const body = config?.body ? config?.body : undefined;
        const headers = config?.headers
          ? config?.headers
          : undefined;
        const content =
          method === HttpMethods.POST || HttpMethods.PUT ? [body, headers] : [headers];
        const res = await config.instance[method](config.url, ...content);
        responseAction(fullResponse ? res : res?.data);
        setError(false);
      } catch (err) {
        if (err?.response?.status != 401) {
        setError(true);
        if (failureAction) {
          failureAction(err);
        } else {
          displayToastMessage(err.detail, "error");
        }
      }
      }
    },
    []
  );
  return { sendRequest, error };
};

export default useHttp;
